import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// Fetch all appointments
export const fetchAppointments = createAsyncThunk(
  "appointments/fetchAppointments",
  async (_, thunkAPI) => {
    try {
      const res = await fetch("/api/v1/appointments");
      if (!res.ok) throw new Error("Failed to fetch appointments");
      return await res.json();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

// Update appointment status
export const updateAppointmentStatus = createAsyncThunk(
  "appointments/updateAppointmentStatus",
  async ({ id, status }, thunkAPI) => {
    try {
      const res = await fetch(`/api/v1/appointments/${id}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ appointment: { status } }),
      });
      if (!res.ok) throw new Error("Failed to update appointment status");
      return await res.json();
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

//  Delete appointment
export const deleteAppointment = createAsyncThunk(
  "appointments/deleteAppointment",
  async (id, thunkAPI) => {
    try {
      const res = await fetch(`/api/v1/appointments/${id}`, {
        method: "DELETE",
      });
      if (!res.ok) throw new Error("Failed to delete appointment");
      return id; // return deleted id
    } catch (err) {
      return thunkAPI.rejectWithValue(err.message);
    }
  }
);

const appointmentsSlice = createSlice({
  name: "appointments",
  initialState: {
    appointments: [],
    loading: false,
    error: null,
  },
  reducers: {  
     // Realtime reducers (for ActionCable events)
    addAppointment: (state, action) => {
      // avoid duplicates if appointment already exists
      const exists = state.appointments.find((a) => a.id === action.payload.id);
      if (!exists) {
        state.appointments.unshift(action.payload);
      }
    },
    updateAppointment: (state, action) => {
      state.appointments = state.appointments.map((appt) =>
        appt.id === action.payload.id ? action.payload : appt
      );
    },
    removeAppointment: (state, action) => {
      state.appointments = state.appointments.filter(
        (appt) => appt.id !== action.payload
      );
    },
  },
  extraReducers: (builder) => {
    builder
      //  Fetch
      .addCase(fetchAppointments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAppointments.fulfilled, (state, action) => {
        state.loading = false;
        state.appointments = action.payload;
      })
      .addCase(fetchAppointments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Update
      .addCase(updateAppointmentStatus.fulfilled, (state, action) => {
        state.appointments = state.appointments.map((appt) =>
          appt.id === action.payload.id ? action.payload : appt
        );
      })
      //  Delete
      .addCase(deleteAppointment.fulfilled, (state, action) => {
        state.appointments = state.appointments.filter(
          (appt) => appt.id !== action.payload
        );
      });
  },
});

export const {
  addAppointment,
  updateAppointment,
  removeAppointment,
} = appointmentsSlice.actions;

export const selectAppointments = (state) => state.appointments.appointments;
export const selectAppointmentsLoading = (state) => state.appointments.loading;
export const selectAppointmentsError = (state) => state.appointments.error;

export default appointmentsSlice.reducer;
